import {RouteDefinition} from '../../../../../routes';
import {LeftMenuListScreen} from './LeftMenuListScreen';
import {LeftMenuEditScreen} from './LeftMenuEditScreen';
import {ContentListScreen} from './ContentListScreen';
import {ContentEditScreen} from './ContentEditScreen';

export const LeftMenuSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/left-menu',
        component: LeftMenuListScreen,
    },
    {
        routerLink: '/settings/left-menu/edit/:id',
        component: LeftMenuEditScreen,
    },
    {
        routerLink: '/settings/left-menu/edit/',
        component: LeftMenuEditScreen,
    },
    {
        routerLink: '/settings/left-menu/:id/contents/',
        component: ContentListScreen,
    },
    {
        routerLink: '/settings/left-menu/:menu_id/contents/edit/',
        component: ContentEditScreen,
    },
    {
        routerLink: '/settings/left-menu/:menu_id/contents/edit/:type/:rel_id?',
        component: ContentEditScreen,
    },
];
